/**
 * Utility functions for device detection
 */
import {fetchWrapper} from '../../../../utills/fetchWrapper'
import {CLIENT_IP_INFO_URL, CONTENT_TYPE} from '../../../../constants'

/**
 * Detects the device type based on the user agent string
 * @returns {string} Returns 'PHONE' for mobile devices or 'WEB' for desktop/other devices
 */
export const getDeviceType = () => {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? 'PHONE'
        : 'WEB'
}

export const getClientIpInfo = async () => {
    try {
        const response = await fetchWrapper(CLIENT_IP_INFO_URL, {
            method: 'GET',
            headers: {
                'Content-Type': CONTENT_TYPE.JSON
            },
            credentials: 'include'
        })
        const responseJson = await response.json()
        const ipInfo = responseJson?.ipInfo || ''
        return ipInfo
    } catch (error) {
        return ''
    }
}
